/*
 * Copyright (c) 2026 CalAmp Corp.  All Rights Reserved
 */
import React from 'react';
import {IconProps} from '../../types/types';
import useIconDLS from '../useIconDLS';

/*
 * Defines the Design Language System (DLS) Power On/Off Icon component.
 */
export const PowerOnOffIcon = (props: IconProps) => {
  const {iconSize, iconColor} = useIconDLS(props);
  return (
    <svg width={iconSize} height={iconSize} viewBox='0 0 24 24' fill='none' xmlns='http://www.w3.org/2000/svg'>
      <path d='M12 6.5V13.1725M8.66667 8.50919C7.64375 9.39996 7 10.6945 7 12.1352C7 14.822 9.23858 17 12 17C14.7614 17 17 14.822 17 12.1352C17 10.6945 16.3562 9.39996 15.3333 8.50919' stroke={iconColor} strokeWidth='1.5' strokeLinecap='round' />
      <path d='M12 2.75C17.1086 2.75 21.25 6.89137 21.25 12C21.25 17.1086 17.1086 21.25 12 21.25C6.89137 21.25 2.75 17.1086 2.75 12C2.75 6.89137 6.89137 2.75 12 2.75Z' stroke={iconColor} strokeWidth='1.5' />
    </svg>
  );
};

export default PowerOnOffIcon;
